export default __webpack_public_path__ + "static/media/img5.855789c6.jpg";